import React, { FunctionComponent, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import AudiExclusiveApp from '../audi-exclusive-app/audiExclusiveAppContainer'
import Cartbox from '../cartbox'
import ConflictModal from '../conflict-modal'
import CornerRibbon from '../corner-ribbon'
import ForesightedBuildabilityModal from '../foresighted-buildability-modal'
import InfoModal from '../info-modal'
import ModelConflictModal from '../model-conflict-modal'
import Navigation from '../navigation'
import RescueVehicleCodeModal from '../rescue-vehicle-code-modal'
import Router from '../router'
import Sidebar from '../sidebar'
import style from './root.css'
import TargetNavigation from '../target-navigation/targetNavigationContainer'
import PrStringInvocationModal from '../invocation-modal'
import InfoModalInteriorCombination from '../info-modal-interior-combination'
import E3DAppInitializer from '../e3d-components/e3d-app-initializer'
import { shouldShowCartbox } from '../../utils/cartboxVisibility'
import E3DLoadingSpinner from '../e3d-components/e3d-loading-spinner/e3DLoadingSpinnerContainer'
import VinAlternativesModal from '../vin-alternatives-modal'
import { E3DReinitProvider } from '../e3d-components/e3d-context/E3DReinitContext'
import is3DExhibitionEnabledSelector from '../../redux/selectors/feature-scope/is3DExhibitionEnabledSelector'
import E3DSharingDashboard from '../e3d-components/e3d-sharing-dashboard/E3DSharingDashboard'
import e3dSharingDashboardSelector from '../../redux/selectors/e3dSharingDashboardSelector'
import { hideE3DSharingDashboard, showE3DSharingDashboard } from '../../redux/actions/app/e3dSharingDashboard.actions'
import RecommendationsComponent from '../recommendations-component/recommendationsContainerWrapper'

const PageContent: FunctionComponent = () => {
    const { pathname } = useLocation()
    const dispatch = useDispatch()
    const cartboxDisplayClass = shouldShowCartbox(pathname) ? style.cartboxDisplayed : style.cartboxHidden
    const is3DExhibitionEnabled = useSelector(is3DExhibitionEnabledSelector)
    const isE3DSharingVisibleFromRedux = useSelector(e3dSharingDashboardSelector)

    // Local state for button-triggered display (backward compatibility)
    const [isE3DSharingVisibleLocal, setIsE3DSharingVisibleLocal] = useState(false)

    // Combine Redux and local state - show if either is true
    const isE3DSharingVisible = isE3DSharingVisibleFromRedux || isE3DSharingVisibleLocal

    // Sync local state changes to Redux
    useEffect(() => {
        if (isE3DSharingVisibleLocal && !isE3DSharingVisibleFromRedux) {
            dispatch(showE3DSharingDashboard())
        }
    }, [isE3DSharingVisibleLocal, isE3DSharingVisibleFromRedux, dispatch])

    // Handle close - clear both Redux and local state
    const handleClose = () => {
        setIsE3DSharingVisibleLocal(false)
        dispatch(hideE3DSharingDashboard())
    }

    const content = (
        <div className={style.pageContainer}>
            <CornerRibbon />
            <Sidebar>
                <Navigation setE3DSharingVisible={setIsE3DSharingVisibleLocal} />
            </Sidebar>
            <main className={style.pageContent}>
                <Router />
                <ConflictModal />
                <ForesightedBuildabilityModal />
                <InfoModal />
                <InfoModalInteriorCombination />
                <ModelConflictModal />
                <RescueVehicleCodeModal />
                <AudiExclusiveApp />
                <TargetNavigation />
                <PrStringInvocationModal />
                <VinAlternativesModal />
                <E3DAppInitializer />
                <E3DLoadingSpinner />
            </main>
            <div className={cartboxDisplayClass}>
                <div className={style.contentWithCartboxStandalone}>
                    <RecommendationsComponent />
                    <Cartbox setE3DSharingVisible={setIsE3DSharingVisibleLocal} />
                </div>
            </div>
            {is3DExhibitionEnabled && isE3DSharingVisible && (
                <E3DSharingDashboard onClose={handleClose} />
            )}
        </div>
    )

    return is3DExhibitionEnabled ? (
        <E3DReinitProvider>
            {content}
        </E3DReinitProvider>
    ) : content
}

export default PageContent
